import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import rateHoursSummaryReportComponent from './rate-hours-summary-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let rateHoursSummaryReportModule = angular.module('rateHoursSummaryReport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('rateHoursSummaryReport', {
    parent: 'app',
    url: '/admin/reports/rateHoursSummaryReport',
    data: {
      pageHeader: true,
      pageTitle: 'Rate and Hours Summary Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<rate-hours-summary-report></rate-hours-summary-report>'
  });

})

.component('rateHoursSummaryReport', rateHoursSummaryReportComponent);

export default rateHoursSummaryReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/rate-hours-summary-report/rate-hours-summary-report.js